import { required } from 'vuelidate/lib/validators'

export default {
  external_id: { required },
  amount_due: { required },
  customers: { required },
  merchant_account: { required },
  due_date: { required },
  minimum_payment: { required },
  maximum_payment: { required }
}
